import { Component, Input, OnInit, OnChanges } from '@angular/core';
import * as jsondiffpatch from 'jsondiffpatch';

import * as html from '../../../../node_modules/jsondiffpatch/lib/formatters/html';

@Component({
  selector: 'app-json-diff-viewer',
  templateUrl: './json-diff-viewer.component.html',
  styleUrls: ['./json-diff-viewer.component.scss'],
})
export class JsonDiffViewerComponent implements OnInit, OnChanges {
  @Input() leftJson: any = {};
  @Input() rightJson: any = {};

  private diffInstance: any;

  showunchanged: any;

  constructor() {
    this.diffInstance = jsondiffpatch.create({
      // Customization options
      arrays: { detectMove: false },
    });
  }

  ngOnInit(): void {
    this.renderDiff();
  }

  ngOnChanges(): void {
    this.renderDiff();
  }

  renderDiff(): void {
    const delta = this.diffInstance.diff(this.leftJson, this.rightJson);
    const container = document.getElementById('diff-container');

    console.log(container);

    if (container) {
      if (delta) {
        console.log(delta);
        let formatData = html.format(delta, this.leftJson);
        //html.hideUnchanged(container);

        container.innerHTML = formatData || '<p>No differences found.</p>';
        html.hideUnchanged(container);
        // container.innerHTML = jsondiffpatch.formatters.html.format(
        //   delta,
        //   this.leftJson
        // );
        // jsondiffpatch.formatters.html.hideUnchanged(container);
      } else {
        container.innerHTML = '<p>No differences found.</p>';
      }
    }
  }

  showUnchange(): void {
    this.renderDiff();
    const container = document.getElementById('diff-container');
    html.showUnchanged(!this.showunchanged, container, 800);
  }
}
